import { NgModule } from '@angular/core';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';

import { ZtFilterComponent } from './zt-filter/zt-filter.component';
import { ZtFooterComponent } from './zt-footer/zt-footer.component';
import { ZtHeaderComponent } from './zt-header/zt-header.component';
import { ZtHistoryTableComponent } from './zt-history-table/zt-history-table.component';
import { ZtSimpleWaveformViewerComponent } from './zt-simple-waveform-viewer/zt-simple-waveform-viewer.component';
import { ZtStringFilterComponent } from './zt-string-filter/zt-string-filter.component';
import { ZtTableComponent } from './zt-table/zt-table.component';
import { ZtDateFilterComponent } from './zt-date-filter/zt-date-filter.component';

import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ZtVariantsFilterComponent } from './zt-variants-filter/zt-variants-filter.component';

@NgModule({
    imports: [
        SharedModule,
        AppRoutingModule,
        CalendarModule,
        MultiSelectModule,
        BrowserAnimationsModule,
    ],
    exports: [
        SharedModule,
        ZtFooterComponent,
        ZtHeaderComponent,
        ZtSimpleWaveformViewerComponent,
        ZtTableComponent,
        ZtHistoryTableComponent,
        ZtFilterComponent,
        ZtStringFilterComponent,
        ZtDateFilterComponent,
        ZtVariantsFilterComponent,
    ],
    declarations: [
        ZtFooterComponent,
        ZtHeaderComponent,
        ZtSimpleWaveformViewerComponent,
        ZtTableComponent,
        ZtHistoryTableComponent,
        ZtFilterComponent,
        ZtStringFilterComponent,
        ZtDateFilterComponent,
        ZtVariantsFilterComponent,
    ],
    providers: [],
})
export class ComponentsModule {}
